export enum SubSubserviceEnum {
  SubService = 'SUBSERVICE'
}

export enum SubServiceEnumApi {
  SubService = 'subServices/'
}
